export default __webpack_public_path__ + "static/media/oddsFeed2.344f82db.png";